// interactable.ts
import { Track, Tap, Press, Rotate, Pan, Swipe, Swivel, Pinch, Pull } from "westures";
var SIXTY_FPS = 1e3 / 60;
var FRICTION = 0.95;
var MULTI = 7;
var LIMIT = 0.1;
var MAX_V = 7;
function reduce(value) {
  value *= FRICTION;
  return Math.abs(value) < LIMIT ? 0 : value;
}
var WesturesInteractable = class {
  constructor({ element, region }) {
    this.rotation = 0;
    this.scale = 1;
    this.x = 0;
    this.y = 0;
    this.velocityX = 0;
    this.velocityY = 0;
    this.animate = false;
    this.update_fn = this.update.bind(this);
    this.swipe_fn = this.swipeAnimation.bind(this);
    this.element = element;
    this.region = region;
    const fns = {
      end: (data) => {
        if (data.active.length == 0) {
          this.animate = false;
        }
      },
      start: () => {
        this.animate = true;
        requestAnimationFrame(this.update_fn);
        clearInterval(this.swipe_interval);
      }
    };
    region.addGesture(new Track(this.element, (data) => fns[data.phase](data), { phases: Object.keys(fns) }));
  }
  update() {
    const rotate = `rotate(${this.rotation}rad) `;
    const translate = `translate(${this.x * this.scale}px, ${this.y * this.scale}px) `;
    const scale = `scale(${this.scale}) `;
    this.element.style.transform = translate + rotate + scale;
    if (this.animate) {
      requestAnimationFrame(this.update_fn);
    }
  }
  swipeAnimation() {
    this.x += this.velocityX;
    this.y += this.velocityY;
    this.velocityX = reduce(this.velocityX);
    this.velocityY = reduce(this.velocityY);
    if (this.velocityY === 0 && this.velocityX === 0) {
      clearInterval(this.swipe_interval);
    }
    requestAnimationFrame(this.update_fn);
  }
  addTap(callback, options) {
    this.region.addGesture(new Tap(this.element, () => callback(this), options));
    return this;
  }
  addPress(callback, options) {
    this.region.addGesture(new Press(this.element, () => callback(this), options));
    return this;
  }
  addRotate(callback, options) {
    this.region.addGesture(new Rotate(this.element, (data) => callback(this, data), options));
    return this;
  }
  addPan(callback, options) {
    this.region.addGesture(new Pan(this.element, (data) => callback(this, data), options));
    return this;
  }
  addSwipe(callback, options) {
    this.region.addGesture(new Swipe(this.element, (data) => callback(this, data), options));
    return this;
  }
  addSwivel(callback, options) {
    this.region.addGesture(
      new Swivel(this.element, (data) => callback(this, data), {
        pivotCenter: this.element,
        ...options
      })
    );
    return this;
  }
  addPinch(callback, options) {
    this.region.addGesture(new Pinch(this.element, (data) => callback(this, data), options));
    return this;
  }
  addPull(callback, options) {
    this.region.addGesture(
      new Pull(this.element, (data) => callback(this, data), {
        pivotCenter: this.element,
        ...options
      })
    );
    return this;
  }
};
var WesturesTransformInteractable = class extends WesturesInteractable {
  constructor() {
    super(...arguments);
    this.zooming = false;
  }
  zoom(scale) {
    this.scale = Math.max(1, scale);
    this.zooming = this.scale > 1;
    if (!this.zooming) {
      this.x = 0;
      this.y = 0;
    }
  }
  addTap(options) {
    return super.addTap(() => this.zoom(this.scale < 1.5 ? this.scale * 2 : 1), options);
  }
  addRotate(options) {
    return super.addRotate((i, data) => this.rotation += data.rotation, options);
  }
  addPan(options) {
    return super.addPan((i, data) => {
      if (!this.zooming)
        return;
      this.x += data.translation.x / this.scale;
      this.y += data.translation.y / this.scale;
    }, options);
  }
  addSwipe(options) {
    return super.addSwipe((i, data) => {
      const velocity = data.velocity > MAX_V ? MAX_V : data.velocity;
      this.velocityX = velocity * Math.cos(data.direction) * MULTI;
      this.velocityY = velocity * Math.sin(data.direction) * MULTI;
      this.swipe_interval = setInterval(this.swipe_fn, SIXTY_FPS);
    }, options);
  }
  addSwivel(options) {
    return super.addSwivel((i, data) => this.rotation += data.rotation, options);
  }
  addPinch(options) {
    return super.addPinch((i, data) => this.zoom(this.scale * data.scale), options);
  }
  addPull(options) {
    return super.addPull((i, data) => this.zoom(this.scale * data.scale), options);
  }
};
export {
  FRICTION,
  LIMIT,
  MAX_V,
  MULTI,
  SIXTY_FPS,
  WesturesInteractable,
  WesturesTransformInteractable
};
